import typography from "../typography"
import colors from "../colors"

export const themeAnt = {
  token: {
    fontFamily: typography.fonts.body,
    colorPrimary: colors.primary["600"],
  },
}
